import { render, staticRenderFns } from "./AsACoachMenu.vue?vue&type=template&id=325ed52c&scoped=true"
import script from "./AsACoachMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./AsACoachMenu.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AsACoachMenu.vue?vue&type=style&index=0&id=325ed52c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325ed52c",
  null
  
)

export default component.exports